import { evaluationsBackend } from '@/application/api';

const evaluationsRoute = 'prospect-external-information';

export const getExternalProviderConnectToken = async () => {
  const { data } = await evaluationsBackend.get(`${evaluationsRoute}/get-pluggy-connect-token`);
  return data.accessToken;
};

export const widgetIsUse = async itemId => {
  return evaluationsBackend.get(`${evaluationsRoute}/widget-use/${itemId}`);
};
